import { Component, OnInit, OnDestroy, Input, Inject } from '@angular/core';
import { totaleFormat } from '@shared/shared-functions';

@Component({
    selector: 'fb-contributi-versati',
    templateUrl: './contributi-versati.component.html',
    styleUrls: ['./contributi-versati.component.scss'],
})

/**
 * Dettagli contributi versati presi dalla dichiarazione
 */
export class ContributiVersatiComponent implements OnInit {
    @Input() contributiVersati: { descrizione: string; importo: number }[] = [];

    constructor() {}

    ngOnInit(): void {}

    totaleImportoFormat(cellInfo: any) {
        return totaleFormat(cellInfo);
    }
}
